import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "offcanvas-header" }
const _hoisted_2 = { class: "offcanvas-body" }
const _hoisted_3 = {
  key: 0,
  class: "cart-list scroll-bar"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "ms-3 d-inline-block text-truncate" }
const _hoisted_7 = { class: "d-flex justify-content-between align-items-center cart-item" }
const _hoisted_8 = { class: "fs-15 mb-0" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-center cart-item" }
const _hoisted_10 = {
  key: 1,
  class: "text-center mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([
      'offcanvas offcanvas-end cart-offcanvas',
      { show: _ctx.stateStoreInstance.show },
    ])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "offcanvas-title h3" }, "All Cart", -1)),
        _createElementVNode("button", {
          type: "button",
          class: "btn-close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.cartModal && _ctx.stateStoreInstance.cartModal(...args)))
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.cartStore.cart.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartStore.cart, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "d-flex justify-content-between align-items-center cart-item",
                  key: item.id
                }, [
                  _createElementVNode("button", {
                    class: "p-0 border-0 bg-transparent delete-btn",
                    onClick: ($event: any) => (_ctx.cartStore.removeFromCart(item.id))
                  }, _cache[3] || (_cache[3] = [
                    _createElementVNode("i", { class: "ri-delete-bin-7-line" }, null, -1)
                  ]), 8, _hoisted_4),
                  _createVNode(_component_RouterLink, {
                    class: "dropdown-item d-flex align-items-center",
                    to: "/product-details"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: item.image,
                        alt: item.name
                      }, null, 8, _hoisted_5),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", null, _toDisplayString(item.name), 1),
                        _createElementVNode("h3", null, "$" + _toDisplayString(item.price), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128)),
              _createElementVNode("li", _hoisted_7, [
                _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "fs-15 mb-0" }, "Total", -1)),
                _createElementVNode("h3", _hoisted_8, "$" + _toDisplayString(_ctx.cartStore.totalPrice.toFixed(2)), 1)
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createVNode(_component_RouterLink, {
                  onClick: _ctx.stateStoreInstance.cartModal,
                  to: "/cart",
                  class: "btn btn-primary fs-14 text-white"
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createElementVNode("span", { class: "border-style" }, "View Cart", -1)
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_RouterLink, {
                  to: "/checkout",
                  class: "btn btn-warning fs-14 text-white"
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createElementVNode("span", { class: "border-style" }, "Checkout", -1)
                  ])),
                  _: 1
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_10, "Your cart is empty."))
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(['offcanvas-backdrop fade', { show: _ctx.stateStoreInstance.show }]),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.cartModal && _ctx.stateStoreInstance.cartModal(...args)))
    }, null, 2)
  ], 64))
}